import {
  LoadingMakeupActivityState,
  MakeupActivityRequest,
  MakeupActivityScheduleRequest,
} from '@tsin-core/models/makeup-activity.model';

export class GetMakeupActivities {
  static readonly type = '[MakeupActivity] Get Makeup Activities By Schedule and Session';
  constructor(public payload: MakeupActivityScheduleRequest) {}
}

export class UpdateMakeupActivity {
  static readonly type = '[MakeupActivity] Update';
  constructor(public payload: MakeupActivityRequest) {}
}

export class SetMakeupActivityLoading {
  static readonly type = '[MakeupActivity] Set Loading';
  constructor(public loading: LoadingMakeupActivityState) {}
}

export class SetMakeupActivityError {
  static readonly type = '[MakeupActivity] Set Error';
  constructor(public error: string | null) {}
}
